import React, { createContext, useContext, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { useNotifications } from '../hooks/useNotifications';
import { useUserCustomization } from '../hooks/useUserCustomization';
import { ROUTE_CONFIG, DISCOVERY_ROUTE_CONFIG } from '../constants/routes';

// Notifications are only currently rendered on these routes, so we want to restrict polling to them.
const NOTIFICATION_POLLING_ROUTES = new Set([ROUTE_CONFIG.home.path, DISCOVERY_ROUTE_CONFIG.inventory.path]);

const NotificationsPanelContext = createContext({
    notifications: [],
    isLoading: false,
    refreshNotifications: () => {},
});

export const useNotificationsPanel = () => useContext(NotificationsPanelContext);

export const NotificationsPanelProvider = ({ children }) => {
    const { pathname } = useLocation();
    const orgId = useMemo(() => sessionStorage.getItem('userOrg'), []);
    const { notificationItems, saveNotificationItems, isLoading: isCustomizationLoading } = useUserCustomization();
    const { notifications, isLoading, refreshNotifications } = useNotifications({
        orgId,
        notificationItems,
        saveNotificationItems,
        isCustomizationLoading,
        pollingInterval: NOTIFICATION_POLLING_ROUTES.has(pathname) ? 5 * 60 * 1000 : undefined,
    });

    return (
        <NotificationsPanelContext.Provider value={{ notifications, isLoading, refreshNotifications }}>
            {children}
        </NotificationsPanelContext.Provider>
    );
};
